const Pizzas = [
    {
        name: "Double Cheese Margherita [BIG 10'']",
        detail: "Good Ol' Classic | Serves 2-3.",
        price: " 345",
        img: "images/pizzas/p8.jpg"
    },
    {
        name: "Any 2 Big 10' Pizzas [Get ₹75 Credits Back]",
        detail: "Mushroom | Black Olive | Spicy Jalapeno ",
        price: " 695",
        img: "images/pizzas/p5.jpg"
    },
    {
        name: "Any 2 Big 10' Pizzas + Any 2 Desserts",
        detail: "Mushroom | Black Olive | Spicy Jalapeno",
        price: "670",
        img: "images/pizzas/p3.jpg"
    },
    {
        name: "Farmer's Market [BIG 10'']",
        detail: "Capsicum | Onion | Serves 2-3.",
        price: " 345",
        img: "images/pizzas/p4.jpg"
    },
    {
        name: "Awesome Threesome [BIG 10'']",
        detail: "Black Olive | Golden Corn | Capsicum | Serves 2-3.",
        price: " 425",
        img: "images/pizzas/p2.jpg"
    },
    {
        name: "Spicy Mexicano [BIG 10'']",
        detail: "Red Paprika | Spicy Jalapeno | Golden Corn ",
        price: " 655",
        img: "images/pizzas/p6.jpg"
    },
    {
        name: "Magic Mushrooms [BIG 10'']",
        detail: "Mushroom | Capsicum | Tomato | Serves 2-3.",
        price: " 400",
        img: "images/pizzas/p7.jpg"
    },
    {
        name: "Veggie Paradise [BIG 10'']",
        detail: "Black Olive | Red Paprika | Capsicum | Tomato",
        price: " 485",
        img: "images/pizzas/p1.jpg"
    },
    {
        name: "Super large veg Magis pizza",
        detail: "Capsicum | Onion | Capsicum | Serves 2-3",
        price: " 600",
        img: "images/pizzas/p9.jpg"
    }
]

export default Pizzas;